import { useEffect, useState, type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { initPortalI18n, i18n } from './initI18n';
import type { PortalLocale } from './constants';
import { persistLocale } from './initI18n';
import { notifyPortalLocaleChange } from './portalLocaleEvents';

type I18nProviderProps = {
  children: ReactNode;
};

export function I18nProvider({ children }: I18nProviderProps) {
  const [ready, setReady] = useState(i18n.isInitialized);

  useEffect(() => {
    if (i18n.isInitialized) {
      setReady(true);
      return;
    }
    void initPortalI18n().then(() => setReady(true));
  }, []);

  useEffect(() => {
    const onLang = (lng: string) => {
      document.documentElement.lang = lng;
    };
    i18n.on('languageChanged', onLang);
    return () => {
      i18n.off('languageChanged', onLang);
    };
  }, []);

  if (!ready) {
    return null;
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

export async function setPortalLocale(locale: PortalLocale): Promise<void> {
  persistLocale(locale);
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
  if (i18n.isInitialized) {
    await i18n.changeLanguage(locale);
  }
  notifyPortalLocaleChange(locale);
}
